import { addClient } from '@/api/client';
import { addCollectiOnorder } from '@/api/collectionOrder';
import { useState } from 'react';
import { useForm } from 'react-hook-form';

const useAddCollectionOrder = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const addCollectionOrderForm = useForm<CollectionOrder>({
    defaultValues: {
      phone: '',
      wilaya: '',
      commune: '',
      totalBalance: '',
      amount: 0,
      date: new Date(new Date().setDate(new Date().getDate() + 1)), // Sets date to tomorrow
      hour: '',
      location: '',
      collectorId: 0,
      customerId: 0,
    },
  });

  const onSubmit = async (
    collectionOrder: CollectionOrder,
    onSuccess: (message: string) => void,
    onError: (message: string) => void
  ) => {
    setIsSubmitting(true);

    const toadd = {
      ...collectionOrder,
      date: collectionOrder.date,
      status: 'Awaiting Collection',
      totalBalance: '0',
      wilaya: collectionOrder.wilaya,
      commune: collectionOrder.commune,
    };

    console.log(toadd);

    try {
      const response = await addCollectiOnorder(toadd);
      console.log('response ', response);
      if (
        response.data.code === 'P2002' &&
        response.data.meta &&
        response.data.meta.target
      ) {
        // Extract the duplicated field from the meta data.
        const duplicatedField = response.data.meta.target.join(', ');
        // Log the error details for debugging purposes.

        // Return an error message in French indicating the duplicated field.
        setIsSubmitting(false);
        return onError(
          `Error : the field ${duplicatedField} is already used. Please choose a different one.`
        );
      } else if (response.status === 201) {
        // If no error, call the success handler.
        setIsSubmitting(false);
        onSuccess('Collection order added successfully');
      }
    } catch (error) {
      setIsSubmitting(false);
      onError('An error occurred while adding the collection order');
    }
  };

  return { isSubmitting, addCollectionOrderForm, onSubmit };
};

export default useAddCollectionOrder;
